export const getStyleOverrides = {
  MuiStepLabel: {
    styleOverrides: {
      labelContainer: {
        textTransform: 'uppercase',
      },
      label: ({theme}) => ({
        color: theme.vars.palette.text.primary,
        fontWeight: 900,
        '&$active': {
          fontWeight: 900,
        },
      }),
    },
  },
  MuiBreadcrumbs: {
    styleOverrides: {
      root: ({theme}) => ({
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        textTransform: 'uppercase',
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottom: 'none',
        '&:first-of-type': {
          //paddingLeft: 0,
        },
        '&:last-child': {
          //paddingRight: 0,
        },
      },
      head: ({theme}) => ({
        color: theme.vars.palette.text.secondary,
        fontWeight: 'bold',
        fontSize: theme.typography.caption.fontSize,
        backgroundColor: '#f2f2f2',
        borderBottom: 'solid 1px #e2e2e2',
      }),
    },
  },
  MuiContainer: {
    styleOverrides: {
      maxWidthXl: {
        maxWidth: '1200px !important',
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      body1: {
        letterSpacing: -0.2,
        fontSize: 16,
      },
      body2: {
        fontSize: 14,
      },
      subtitle1: {
        fontWeight: 700,
        fontSize: 16,
      },
      subtitle2: {
        fontSize: 13,
        letterSpacing: 1,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&$selected': ({theme}) => ({
          backgroundColor: theme.vars.palette.primary.light,
        }),
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'uppercase',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        letterSpacing: -0.2,
      },
    },
  },
};
